export enum DeliveryType {
    BOPIS = 'bopis',
    SDD = 'sdd',
    STM = 'stm',
    AUTOSHIP = 'autoship',
    STH = 'sth',
}
